/* Velmora: show the chosen size next to "Rozmiar" when a shopper picks one */
document.addEventListener('change', function (evt) {
  var input = evt.target;
  if (!input.matches || !input.matches('[data-variant-input]')) return;
  var scope = input.closest('.product-single__meta') || document;
  var label = scope.querySelector('[data-velmora-selected="' + input.dataset.index + '"]');
  if (label) label.textContent = input.value;
});

/* Velmora: on phones, a slim bar with price and "add to cart" appears once the real
   button has scrolled out of view. It presses the real button, so the chosen
   variant, the stock rules and the cart drawer all work as usual. */
(function () {
  function init() {
    var meta = document.querySelector('.product-single__meta');
    var realBtn = meta && meta.querySelector('[data-add-to-cart]');
    var titleEl = meta && meta.querySelector('.product-single__title');
    if (!realBtn || !titleEl || !('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'velmora-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="velmora-sticky-atc__info">' +
        '<span class="velmora-sticky-atc__title"></span>' +
        '<span class="velmora-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="btn velmora-sticky-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);

    var title = bar.querySelector('.velmora-sticky-atc__title');
    var price = bar.querySelector('.velmora-sticky-atc__price');
    var btn = bar.querySelector('.velmora-sticky-atc__btn');
    title.textContent = titleEl.textContent.trim();

    function sync() {
      var priceEl = meta.querySelector('[data-product-price]');
      price.textContent = priceEl ? priceEl.textContent.trim() : '';
      var label = realBtn.querySelector('[data-add-to-cart-text]');
      btn.textContent = (label ? label.textContent : realBtn.textContent).trim();
      btn.disabled = realBtn.disabled;
    }
    sync();
    new MutationObserver(sync).observe(meta, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    btn.addEventListener('click', function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    new IntersectionObserver(function (entries) {
      var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', hidden);
      bar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
      btn.tabIndex = hidden ? 0 : -1;
    }).observe(realBtn);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Velmora: the stock pill follows the chosen variant */
document.addEventListener('variant:change', function (evt) {
  var variant = evt.detail && evt.detail.variant;
  document.querySelectorAll('[data-velmora-stock]').forEach(function (pill) {
    var available = !!(variant && variant.available);
    pill.querySelector('.velmora-pill__dot').classList.toggle('is-out', !available);
    pill.querySelector('[data-velmora-stock-text]').textContent = available ? pill.dataset.in : pill.dataset.out;
  });
});
